if (!customElements.get("countdown-banner")) {
  class CountdownBanner extends HTMLElement {
    constructor() {
      super();
      // 构造函数中只做纯粹的数据声明
      this.date = this.dataset.date;
      this.timestamp = this.getSafeTimestamp(this.date);
      this.interval = null;
      this.countdown = 0;
      this.elements = {};
    }

    /**
     * 元素挂载到 DOM 时触发（此时子元素已就绪）
     */
    connectedCallback() {
      // 1. 初始化 DOM 元素和事件
      this.initElements();
      this.initCloseButton();
      
      // 2. 初始化倒计时数据
      if (this.timestamp == null) {
        this.countdown = 0;
        return;
      }
      
      this.updateCountdown();
      this.updateDOM(); // 初始渲染

      // 3. 只有倒计时未结束且未启动定时器时才启动
      if (this.countdown > 0 && !this.interval) {
        this.startTimer();
      }
    }

    /**
     * 元素从 DOM 移除时触发
     */
    disconnectedCallback() {
      this.stopTimer(); // 清理定时器，避免内存泄漏
    }

    dismiss() {
      this.hidden = true;
      this.stopTimer();
    }

    initElements() {
      this.elements = {
        days: this.querySelector("#times_day"),
        hours: this.querySelector("#times_hour"),
        minutes: this.querySelector("#times_minute"),
        seconds: this.querySelector("#times_second"),
      };
    }

    initCloseButton() {
      const btn = this.querySelector('[data-countdown-close]');
      if (!btn) return;

      if (!this._handleClose) {
        this._handleClose = (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.dismiss();
        };
      }

      btn.removeEventListener('click', this._handleClose);
      btn.addEventListener('click', this._handleClose);
    }

    getSafeTimestamp(dateStr) {
      if (!dateStr || !String(dateStr).trim()) return null;

      let str = String(dateStr).trim().replace(/\//g, "-");

      const tzMap = {
        PST: -8, PDT: -7, CST: -6, CDT: -5,
        EST: -5, EDT: -4, MST: -7, MDT: -6,
        UTC: 0, GMT: 0,
      };

      let tzOffset = null;
      const tzMatch = str.match(/ ?([A-Z]{3,4})$/i);
      if (tzMatch && tzMap[tzMatch[1].toUpperCase()] !== undefined) {
        tzOffset = tzMap[tzMatch[1].toUpperCase()];
        str = str.slice(0, -tzMatch[0].length).trim();
      }

      const parts = str.match(
        /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/
      );

      if (!parts) return null;

      const year = parseInt(parts[1], 10);
      const month = parseInt(parts[2], 10) - 1;
      const day = parseInt(parts[3], 10);
      const hour = parseInt(parts[4] || "0", 10);
      const minute = parseInt(parts[5] || "0", 10);
      const second = parseInt(parts[6] || "0", 10);

      // 严格校验日期的合法性（防止 2月31日 这种非法日期通过）
      const checkDate = new Date(Date.UTC(year, month, day, hour, minute, second));
      if (checkDate.getUTCMonth() !== month || checkDate.getUTCDate() !== day) {
        return null; 
      }

      if (tzOffset !== null) {
        return Date.UTC(year, month, day, hour, minute, second) - tzOffset * 3600000;
      }

      // 无时区：按访客本地时区理解
      const localMs = new Date(year, month, day, hour, minute, second).getTime();
      return isNaN(localMs) ? null : localMs;
    }

    updateCountdown() {
      this.countdown = Math.max(0, this.timestamp - Date.now());
    }

    startTimer() {
      if (this.interval) return;
      if (!this.elements.days && !this.elements.hours && !this.elements.minutes && !this.elements.seconds) {
        return;
      }

      this.interval = setInterval(() => {
        this.updateCountdown();
        this.updateDOM();

        if (this.countdown === 0) {
          this.stopTimer();
        }
      }, 1000);
    }

    stopTimer() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    calculateTimeUnits() {
      const SECOND = 1000;
      const MINUTE = SECOND * 60;
      const HOUR = MINUTE * 60;
      const DAY = HOUR * 24;

      return {
        days: Math.floor(this.countdown / DAY),
        hours: Math.floor((this.countdown % DAY) / HOUR),
        minutes: Math.floor((this.countdown % HOUR) / MINUTE),
        seconds: Math.floor((this.countdown % MINUTE) / SECOND),
      };
    }

    updateDOM() {
      const timeUnits = this.calculateTimeUnits();
      Object.entries(timeUnits).forEach(([unit, value]) => {
        if (this.elements[unit]) {
          this.elements[unit].textContent = value.toString().padStart(2, "0");
        }
      });
    }
  }

  customElements.define("countdown-banner", CountdownBanner);
}